import "@/App.css";
import { ReactLenis } from "lenis/react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Signup from "@/components/Signup";
import Footer from "@/components/Footer";

export default function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, wheelMultiplier: 0.9 }}>
      <div className="min-h-screen bg-[#050505] font-sans text-white antialiased">
        <Header />
        <main>
          <Hero />
          <Signup />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}
